import { useContext } from 'react'
import { PlaybookViewContext } from '../contexts/playbookViewContext'

export const usePlaybookViewContext = () => {
  const context = useContext(PlaybookViewContext)

  if (!context) {
    throw new Error(
      'usePlaybookViewContext must be used within a PlaybookViewProvider'
    )
  }

  return context
}
